module.exports = [{
      plugin: require('../node_modules/gatsby-theme-starberry-lomondgroup-v4/gatsby-browser.js'),
      options: {"plugins":[],"news_insight":"news-and-insights","branch_finder":"branch-finder","area_cover":"area-guides","teams":"meet-the-team","guides_resources":"guides-and-resources","job_details":"careers/job-details","case_study":"case-study"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"/opt/build/repo/static/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"183efad1cc94ba2bef7bd860f63a0dac"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
